/* BLE222ED shelf: size pick + add to cart for every .shelf__card on the page. Loads once, delegates clicks. */
(function(){
if(window.__bleShelf) return; window.__bleShelf=1;
document.addEventListener('click',function(e){
var sz=e.target.closest('.shelf__size');
if(sz){
var c=sz.closest('[data-card]'), add=c.querySelector('[data-add]'), price=c.querySelector('[data-price]');
c.querySelectorAll('.shelf__size').forEach(function(x){x.classList.remove('is-on');});
sz.classList.add('is-on'); add.dataset.id=sz.dataset.id; price.textContent=sz.dataset.price;
var ok=sz.dataset.avail==='true'; add.disabled=!ok; add.textContent=ok?add.dataset.label:'Sold out';
return;
}
var add=e.target.closest('[data-add]'); if(!add||add.disabled) return;
add.disabled=true; add.textContent='Adding...';
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+add.dataset.id,quantity:1}]})})
.then(function(r){ if(!r.ok) throw 0; window.location.href='/cart'; })
.catch(function(){ add.disabled=false; add.textContent=add.dataset.label; });
});
})();
